import React from 'react';
import { Redirect, Route, Switch, useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import { useAuth } from '~/hooks';
import CompaniesListPage from './CompaniesListPage';
import CompanyCreateForm from './CompanyCreateForm';
import CompanyArea from './CompanyArea';

export default function CompaniesArea() {
  const { path, url } = useRouteMatch();
  const location = useLocation();
  const history = useHistory();
  const auth = useAuth();

  const handleCreate = (company) => {
    history.push(`${url}/${company.id}/overview/edit`);
  };

  return (
    <>
      <Switch>
        <Route path={[`${path}/`, `${path}/new`, `${path}/edit/:companyId`]} exact>
          <CompaniesListPage sessionKey="companies_list" />
        </Route>
        <Route path={`${path}/:companyId`}>
          <CompanyArea />
        </Route>
      </Switch>
      <Route path={`${path}/new`}>
        {auth.companies.create ? (
          <CompanyCreateForm
            onSaved={handleCreate}
            onClose={() => {
              history.push({ pathname: url, search: location.search });
            }}
          />
        ) : (
          <Redirect to={{ pathname: url, search: location.search }} />
        )}
      </Route>
    </>
  );
}
